import { render, staticRenderFns } from "./ReleaseError.vue?vue&type=template&id=285fcd41&scoped=true&"
import script from "./ReleaseError.vue?vue&type=script&lang=js&"
export * from "./ReleaseError.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseError.vue?vue&type=style&index=0&id=285fcd41&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285fcd41",
  null
  
)

export default component.exports